export default "__VITE_ASSET__Dc89krvw__"